'use client';

import { css } from '@bts-web/utils-style-engine';
import { FC, ReactNode } from 'react';
import { BitpandaLogoDark } from '../../../common/assets/BitpandaLogoDark';
import { PoweredByTextType } from '../../utils';
import { getAppConfig } from '@bts-web/core-app-config';
import { useClientTranslation } from '@bts-web/utils-lokalise';

export const PoweredByText: FC<
  PoweredByTextType & { children?: ReactNode }
> = ({ fontSize = 'caption.medium_medium', value, noMargins, children }) => {
  const { t } = useClientTranslation();

  return (
    <div
      data-testid="powered-by-copy"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'neutrals.text_secondary',
        fontWeight: 'body.medium',
        letterSpacing: 'body.medium',
        lineHeight: 'body.medium',
        fontSize: fontSize,
        whiteSpace: 'wrap',
        ...(noMargins ? {} : { mt: 'small', mb: 'medium' }),
      })}
    >
      {value || t('powered_by_@tenant')}
      {children}
    </div>
  );
};

export const PoweredByTextWithLogo = (
  props: Omit<PoweredByTextType, 'children' | 'fontSize'>,
) => {
  const { isByol, appLogo } = getAppConfig();

  const Logo = appLogo;

  return (
    <PoweredByText {...props} fontSize="caption.small">
      {isByol ? <Logo /> : <BitpandaLogoDark />}
    </PoweredByText>
  );
};

export const PoweredBy = ({
  showLogo,
  ...props
}: Omit<PoweredByTextType, 'children' | 'fontSize'> & {
  showLogo?: boolean;
}) =>
  showLogo ? (
    <PoweredByTextWithLogo {...props} />
  ) : (
    <PoweredByText {...props} />
  );
